module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-post-b8b7c5cf.svg";